import { KNOWN_PRODUCT_IDS } from './knownProductIds';
import {
  AAVE_PERP_METADATA,
  ADA_PERP_METADATA,
  APE_PERP_METADATA,
  APT_PERP_METADATA,
  ARB_PERP_METADATA,
  ATOM_PERP_METADATA,
  AVAX_PERP_METADATA,
  BCH_PERP_METADATA,
  BERA_PERP_METADATA,
  BLAST_PERP_METADATA,
  BLUR_PERP_METADATA,
  BNB_PERP_METADATA,
  BRETT_PERP_METADATA,
  BTC_PERP_METADATA,
  COMP_PERP_METADATA,
  CRV_PERP_METADATA,
  DEGEN_PERP_METADATA,
  DOGE_PERP_METADATA,
  DOT_PERP_METADATA,
  DYDX_PERP_METADATA,
  EIGEN_PERP_METADATA,
  ENA_PERP_METADATA,
  ETH_PERP_METADATA,
  FIL_PERP_METADATA,
  GALA_PERP_METADATA,
  GMCI30_PERP_METADATA,
  GMMEME_PERP_METADATA,
  GOAT_PERP_METADATA,
  ICP_PERP_METADATA,
  IMX_PERP_METADATA,
  INJ_PERP_METADATA,
  JTO_PERP_METADATA,
  JUP_PERP_METADATA,
  LDO_PERP_METADATA,
  LINK_PERP_METADATA,
  LTC_PERP_METADATA,
  MEME_PERP_METADATA,
  MKR_PERP_METADATA,
  MNT_PERP_METADATA,
  MPEPE_PERP_METADATA,
  NEAR_PERP_METADATA,
  ONDO_PERP_METADATA,
  OP_PERP_METADATA,
  POL_PERP_METADATA,
  PYTH_PERP_METADATA,
  S_PERP_METADATA,
  SCR_PERP_METADATA,
  SEI_PERP_METADATA,
  SNX_PERP_METADATA,
  SOL_PERP_METADATA,
  STX_PERP_METADATA,
  SUI_PERP_METADATA,
  TIA_PERP_METADATA,
  TON_PERP_METADATA,
  TRUMP_PERP_METADATA,
  TRX_PERP_METADATA,
  WIF_PERP_METADATA,
  WLD_PERP_METADATA,
  XRP_PERP_METADATA,
  ZRO_PERP_METADATA,
} from './perpMetadata';
import { PerpProductMetadata } from './types';

const COMMON_PERP_METADATA_BY_PRODUCT_ID: Record<number, PerpProductMetadata> =
  {
    2: BTC_PERP_METADATA,
    4: ETH_PERP_METADATA,
    6: ARB_PERP_METADATA,
    8: BNB_PERP_METADATA,
    10: XRP_PERP_METADATA,
    12: SOL_PERP_METADATA,
    14: POL_PERP_METADATA,
    16: SUI_PERP_METADATA,
    18: OP_PERP_METADATA,
    20: APT_PERP_METADATA,
    22: LTC_PERP_METADATA,
    24: BCH_PERP_METADATA,
    26: COMP_PERP_METADATA,
    28: MKR_PERP_METADATA,
    30: MPEPE_PERP_METADATA,
    34: DOGE_PERP_METADATA,
    36: LINK_PERP_METADATA,
    38: DYDX_PERP_METADATA,
    40: CRV_PERP_METADATA,
    44: TIA_PERP_METADATA,
    46: PYTH_PERP_METADATA,
    50: JTO_PERP_METADATA,
    52: AVAX_PERP_METADATA,
    54: INJ_PERP_METADATA,
    56: SNX_PERP_METADATA,
    58: ADA_PERP_METADATA,
    60: IMX_PERP_METADATA,
    62: MEME_PERP_METADATA,
    64: SEI_PERP_METADATA,
    66: BLUR_PERP_METADATA,
    68: STX_PERP_METADATA,
    70: NEAR_PERP_METADATA,
    72: LDO_PERP_METADATA,
    74: FIL_PERP_METADATA,
    76: WLD_PERP_METADATA,
    78: ICP_PERP_METADATA,
    80: DOT_PERP_METADATA,
    82: TRX_PERP_METADATA,
    84: GALA_PERP_METADATA,
    86: ATOM_PERP_METADATA,
    88: APE_PERP_METADATA,
    90: JUP_PERP_METADATA,
    96: GMCI30_PERP_METADATA,
    98: GMMEME_PERP_METADATA,
    100: TON_PERP_METADATA,
    102: S_PERP_METADATA,
    104: WIF_PERP_METADATA,
    106: ONDO_PERP_METADATA,
    108: ENA_PERP_METADATA,
    110: MNT_PERP_METADATA,
    130: AAVE_PERP_METADATA,
    132: ZRO_PERP_METADATA,
    134: EIGEN_PERP_METADATA,
    138: SCR_PERP_METADATA,
    140: DEGEN_PERP_METADATA,
    142: GOAT_PERP_METADATA,
    144: BRETT_PERP_METADATA,
    [KNOWN_PRODUCT_IDS.blastPerp]: BLAST_PERP_METADATA,
    148: TRUMP_PERP_METADATA,
    152: BERA_PERP_METADATA,
  };

export const TESTNET_PERP_METADATA_BY_PRODUCT_ID =
  COMMON_PERP_METADATA_BY_PRODUCT_ID;

export const MAINNET_PERP_METADATA_BY_PRODUCT_ID =
  COMMON_PERP_METADATA_BY_PRODUCT_ID;
